/**
 * A product's risk profile as a client sees it: one label and one colour pair per level,
 * the same on every screen. The scale reads upward, never as a warning: green for the
 * steadiest, blue in between, and the brand's gold for the profile that aims at the most
 * growth (owner, 2026-10-14).
 */
export interface RiskLevelStyle {
  readonly label: string;
  readonly color: string;
  readonly bg: string;
}

export const RISK_LEVELS: Readonly<Record<number, RiskLevelStyle>> = {
  1: { label: 'Conservative', color: '#166534', bg: '#DCFCE7' },
  2: { label: 'Moderate', color: '#1E40AF', bg: '#DBEAFE' },
  3: { label: 'Growth', color: '#7A5A12', bg: '#FBF1D9' },
};
